<div class="additional-channel" *ngIf="!isPreview && isEditing">
  <label class="user-select-none">{{
    'labels.additionalMediaChannel' | translate
  }}</label>
  <div class="center-block">
    <div class="left-block">
      <ops-input
        [label]="'labels.newChannelName' | translate"
        formName="channelName"
        [value]="channelName"
        (changed)="setChannelName($event)"
        type="text"
      ></ops-input>
    </div>
    <div class="right-block">
      <button class="cancel-button" (click)="cancelEdit()">
        {{ 'labels.cancel' | translate }}
      </button>
      <button class="save-button" (click)="saveChanges()">
        {{ 'labels.save' | translate }}
      </button>
    </div>
  </div>
</div>
<ops-settings-add-button
  *ngIf="!isPreview && !isEditing"
  [label]="'labels.addSocialMediaChannels' | translate"
  (clicked)="addSocialMediaChannel($event)"
></ops-settings-add-button>
